/**
 * Aspect keys sent as `cropAspect` for bulk copy / default social presets.
 * The converter performs a centered crop of this aspect on each image. Must
 * stay in sync with server/app/helpers/hasValidCropAspect.js + zipper equivalent.
 */
export const BULK_COPY_CROP_ASPECT_KEYS = [
  '1:1',
  '4:3',
  '3:4',
  '4:5',
  '16:9',
  '9:16',
  '1.91:1',
  '2.27:1',
  '3:1',
  '4:1',
  '5.9:1',
];

export function isBulkCopyCropAspect(value) {
  return typeof value === 'string' && BULK_COPY_CROP_ASPECT_KEYS.includes(value);
}
